module.exports = __webpack_public_path__ + "static/media/youtube.77208524.png";